import request from "@/utils/request";

export const BASE_URL = '/api/custom/'

export const customRequest = (url, options={}) => async (data={}, internalOptions={}) =>  {
    const response = await request({
        url: BASE_URL + url,
        method: 'post',
        data,
        ...options,
        ...internalOptions
    })
    console.log('response', response)
    if(String(response.success) === 'true'){
        return response.data
    }else {
        return Promise.reject(response.message)
    }
}
